/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const EntityQuantityReportUpdatePage = lazyLoad(
  () => import('./index'),
  module => module.EntityQuantityReportUpdatePage
);
